module.exports = __webpack_public_path__ + "static/media/southern-company.72b4308f.svg";